import Sortable from "sortablejs";

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-sortable-table]").forEach((table) => {
        const tbody = table.querySelector("tbody");
        if (!tbody) return;

        Sortable.create(tbody, {
            animation: 150,
            handle: "[data-sort-handle]",
            onEnd: function () {
                const ids = Array.from(tbody.children).map((row) => row.dataset.id);
                fetch(table.dataset.sortUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    },
                    body: JSON.stringify({ ids }),
                })
                    .then((response) => {
                        if (!response.ok) throw new Error("Sort failed");
                    })
            },
        });
    });
}); 